import { SubItem } from '../../types/sub-item.types';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import omitBy from 'lodash/fp/omitBy';

export const processBulkEditRow = (
   s: SubItem,
   processedData: any,
   combinedDifferingFields: string[],
   subItemToBomValidFromMap: Map<string, string | null>
): SubItem => {
   const userChangedActive = (() => {
      if ('inactive' in processedData) {
         return combinedDifferingFields.includes('inactive') ? processedData.inactive !== '*' : false;
      }
      return processedData.active !== '*' && processedData.active !== undefined;
   })();

   if ('inactive' in processedData) {
      if (userChangedActive) {
         processedData.active = processedData.inactive === 0;
      }
      delete processedData.inactive;
   }

   let subItemData = omit(processedData, ['locked', 'differingFields', 'subItems', 'clientCreated', 'id', 'parentId', 'matSetName']);

   const bomValidFrom = subItemToBomValidFromMap.get(`${s.parentId}:${s.id}`);

   const filteredSubItemData = omitBy((value: any, key: string) => combinedDifferingFields.includes(key) && value === '*', subItemData);

   const merged = merge({}, s, filteredSubItemData, { bomValidFrom });

   if (!userChangedActive) {
      merged.active = s.active;
   }

   return merged;
};

export const resolveLatestActive = (subItem: SubItem, formActive: boolean | undefined): boolean => {
   return formActive ?? subItem.active;
};
